export default "__VITE_ASSET__a4f07352__"